// extracted by mini-css-extract-plugin
export default {"container":"InteractionSummaryVI_container__8E9Hq","container--verticalPadding":"InteractionSummaryVI_container--verticalPadding__O5-Gp"};